/**
 * Event names for the two registration funnels: retailer and brand.
 *
 * There is no third funnel — the entry steps below are the prefix both funnels
 * share, because they are literally the same components (the email form and the
 * verification-code popin). Each occurrence belongs to exactly one funnel, told
 * apart by `signUp.audience`, which every SignUpEvent carries.
 */
export const SignUpEventNames = {
  // ── Entry steps · both funnels ──────────────────────────────────────────────
  // A chart over these is only meaningful with an audience filter. Mind that
  // `signUp.audience` only exists since 2026-07-22, so the retailer cut is
  // "audience is not brand" rather than "audience is retailer".
  EmailSubmittedEvent: 'Sign Up Pop Up Email Submitted',
  EmailViewedEvent: 'Sign Up Pop Up Email Viewed',
  EmailMandatoryEvent: 'Sign Up Pop Up Email Mandatory Warning',

  EmailValidationViewedEvent: 'Sign Up Email Validation Viewed',
  EmailValidationVerifyClickedEvent: 'Sign Up Email Validation Verify Clicked',
  EmailValidationResendClickedEvent: 'Sign Up Email Validation Resend Clicked',
  EmailValidationBackClickedEvent: 'Sign Up Email Validation Back Clicked',

  GoogleSignInClickedEvent: 'Sign Up Google Sign In Clicked',
  GoogleSignInLoginEvent: 'Sign Up Google Sign In Login',
  GoogleSignInRegisterEvent: 'Sign Up Google Sign In Register',

  NoAccountYetEvent: 'No Account Event',

  // ── Retailer registration funnel ────────────────────────────────────────────
  // The sign-up.vue wizard and its step components.
  AlreadyAccountClickedEvent: 'Sign Up Pop Up Already Account Clicked',

  GeneralInfoSubmittedEvent: 'Sign Up Pop Up General Info Submitted',
  GeneralInfoViewedEvent: 'Sign Up Pop Up General Info Viewed',
  GeneralInfoMandatoryEvent: 'Sign Up Pop Up General Info Mandatory Warning',

  AboutRetailerSubmittedEvent: 'Sign Up Pop Up About Your Business Submitted',
  AboutRetailerViewedEvent: 'Sign Up Pop Up About Your Business Viewed',
  AboutRetailerMandatoryEvent: 'Sign Up Pop Up About Your Business Mandatory Warning',

  ActivityPreferencesSubmittedEvent: 'Sign Up Pop Up Preferences Submitted',
  ActivityPreferencesViewedEvent: 'Sign Up Pop Up Preferences Viewed',
  ActivityPreferencesMandatoryEvent: 'Sign Up Pop Up Preferences Mandatory Warning',

  CompanyNumberSubmittedEvent: 'Sign Up Pop Up Company Number Submitted',
  CompanyNumberViewedEvent: 'Sign Up Pop Up Company Number Viewed',
  CompanyNumberMandatoryEvent: 'Sign Up Pop Up Company Number Mandatory Warning',

  CompanyNumberLaterEvent: 'Sign Up Pop Up Company Number Confirm Later',
  CompanyNumberSoleTraderBack: 'Sign Up Pop Up Company Number Sole Trader Go Back',
  CompanyNumberSoleTrader: 'Sign Up Pop Up Company Number Sole Trader',

  CompanySearchSuggestionClickedEvent: 'Sign Up Company Search Suggestion Clicked',
  SuggestedCompanyAddressChangedEvent: 'Sign Up Suggested Company Address Changed',

  CongratsB2RCTAEvent: 'Sign Up Pop Up Congrats B2R CTA',
  CongratsB2RViewedEvent: 'Sign Up Pop Up Congrats B2R Viewed',

  RequestInformationShownEvent: 'Sign Up Request Information Modal Shown',
  RequestInformationClosedEvent: 'Sign Up Request Information Modal Closed',
  RequestInformationInformationEvent: 'Sign Up Request Information Modal Continued',

  RetailerSignupCompletedEvent: 'Sign Up Completed',

  // ── Brand registration funnel ───────────────────────────────────────────────
  // The registration form reached once the email is verified (SEL-3).
  BrandFormViewedEvent: 'Sign Up Brand Form Viewed',
  BrandFormSubmittedEvent: 'Sign Up Brand Form Submitted',
} as const;

type Keys = keyof typeof SignUpEventNames;
export type SignUpEventNameType = (typeof SignUpEventNames)[Keys];
